const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-5xl mx-auto px-4 py-8 mt-24">
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
          <div className="space-y-6">
            <p className="text-sm text-gray-600">Effective Date: 15-Jan-25</p>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                1. Introduction
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Welcome to www.pixell.in ("we," "our," or "us"). We value your
                privacy and are committed to protecting your personal
                information. This Privacy Policy explains how we collect, use,
                disclose, and safeguard your information when you visit our
                website www.pixell.in, use our tech products, or engage with us
                in any other way.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                2. Information We Collect
              </h2>
              <p className="text-gray-700">
                We may collect information about you in various ways, including:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                  <span className="font-medium">Personal Data:</span> Name,
                  email address, phone number, etc., when you register or
                  contact us.
                </li>
                <li>
                  <span className="font-medium">Usage Data:</span> Information
                  about your interaction with our website and services, such as
                  IP address, browser type, and pages visited.
                </li>
                <li>
                  <span className="font-medium">Location Data:</span> Our
                  application collects precise and approximate location data
                  from your device, including GPS location, latitude and
                  longitude coordinates, and network-based location data, when
                  you grant permission.
                  <p className="text-gray-700 my-4">
                    We use location data for the following purposes:
                  </p>
                  <ol className="list-decimal pl-6 mt-2 space-y-2 text-gray-700">
                    <li>
                      To show nearby job opportunities based on your current
                      location
                    </li>
                    <li>
                      To sort and display the nearest jobs first for a better
                      user experience
                    </li>
                    <li>To support navigation to the job/store location</li>
                    <li>
                      To verify that a job has been completed at the correct
                      store location
                    </li>
                    <li>
                      To update latitude and longitude in our backend so nearby
                      users can receive notifications about new job
                      opportunities
                    </li>
                    <li>
                      To improve app functionality through location-based
                      services
                    </li>
                  </ol>
                  <p className="text-gray-700 my-4">
                    Location data is accessed only when required for app
                    functionality and only after you allow location permission
                    on your device.
                  </p>
                  <p className="text-gray-700 my-4">
                    You can disable location access at any time through your
                    device settings, but some features of the app may not work
                    properly without location permission.
                  </p>
                  <p className="text-gray-700 my-4">
                    We do not sell your location data to third parties. Location
                    data may only be shared with trusted service providers when
                    necessary for app functionality and in compliance with
                    applicable laws.
                  </p>
                </li>

                <li>
                  <span className="font-medium">
                    Cookies and Tracking Technologies:
                  </span>{" "}
                  We use cookies to improve user experience and analyze website
                  traffic.
                </li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                3. How We Use Your Information
              </h2>
              <p className="text-gray-700">
                We may use the information we collect for purposes including:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>To provide, operate, and maintain our services</li>
                <li>To improve, personalize, and expand our services</li>
                <li>To communicate with you, including for customer support</li>
                <li>To process transactions and send notifications</li>
                <li>To prevent fraudulent activities</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                4. Sharing Your Information
              </h2>
              <p className="text-gray-700">
                We do not share your personal information with third parties
                except in the following cases:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                  With service providers who assist in operating our services
                </li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights and safety</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                5. Security of Your Information
              </h2>
              <p className="text-gray-700">
                We use administrative, technical, and physical security measures
                to protect your personal information. However, no method of
                transmission over the Internet is 100% secure.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                6. Your Privacy Rights
              </h2>
              <p className="text-gray-700">
                Depending on your location, you may have the following rights:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                  The right to access and obtain a copy of your personal data
                </li>
                <li>The right to rectify inaccurate information</li>
                <li>The right to request deletion of your data</li>
                <li>The right to object to or restrict processing</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                7. Changes to This Privacy Policy
              </h2>
              <p className="text-gray-700">
                We may update this Privacy Policy from time to time. Changes
                will be posted on this page with an updated effective date.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                8. Contact Us
              </h2>
              <p className="text-gray-700">
                If you have any questions about this Privacy Policy, please
                contact us at:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  Email:{" "}
                  <a
                    href="mailto:support@pixell.in"
                    className="text-indigo-600 hover:text-indigo-800"
                  >
                    support@pixell.in
                  </a>
                </p>
                <p className="text-gray-700">
                  Address: 9, New Tikona Park, N.I.T Faridabad, Haryana - 121001
                </p>
              </div>
            </section>

            <footer className="pt-8 mt-8 border-t border-gray-200">
              <p className="text-gray-600 text-sm text-center">
                By using our website and services, you consent to the terms of
                this Privacy Policy.
              </p>
              <p className="text-gray-600 text-sm text-center mt-4">
                Signthought Solutions Pvt. Ltd.
                <br />
                9, New Tikona Park, N.I.T Faridabad, Haryana - 121001
              </p>
            </footer>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Privacy;

// import { useState } from "react";
// import { translations } from "./translations";

// const Privacy = () => {
//   const [language, setLanguage] = useState("en");

//   return (
//     <>
//       <div className="min-h-screen bg-gray-50">
//         <main className="max-w-5xl mx-auto px-4 py-8 mt-24">
//           <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
//             <div className="space-y-6">
//               <div className="flex justify-between mb-4">
//                 <p className="text-sm text-gray-600">
//                   Effective Date: 15-Jan-25
//                 </p>
//                 <select
//                   value={language}
//                   onChange={(e) => setLanguage(e.target.value)}
//                 >
//                   <option value="en">English</option>
//                   <option value="hi">हिंदी</option>
//                 </select>
//               </div>

//               <div
//                 dangerouslySetInnerHTML={{
//                   __html: translations[language],
//                 }}
//               />
//             </div>
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default Privacy;
